import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const Splits = () => {
  const updatePaymentAccount = (id, data = {}) =>
    AuthAxios.patch(`${DataApiUrl}/admin/splits/${id}/paymentAccount`, data).then(res => res.data);
  return { updatePaymentAccount };
};

export default Splits;
